import {ChangeDetectionStrategy, Component, Input, Output, EventEmitter, OnInit, AfterViewChecked } from "@angular/core";

import { ActivatedRoute, Params, Router  } from '@angular/router';
import {Observable} from 'rxjs/Observable';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { PaginationInstance } from 'ngx-pagination';

import {ApiService} from '../../services/api.service';
import { CalendarYearDetailDateComponent } from '../../components/calendar-year-detail-date/calendar-year-detail-date.component'; 
import { CalendarYearDetailNoteComponent } from '../../components/calendar-year-detail-note/calendar-year-detail-note.component';
import { CalendarYearDetailServiceComponent } from '../../components/calendar-year-detail-service/calendar-year-detail-service.component';
import { CalendarService } from '../../services/calendar.service'; 
import { CalendarYearSelectServiceComponent } from "../calendar-year-select-service/calendar-year-select-service.component";
import { Service } from "app/modules/admin/services/service.service";
import { identifierName } from "@angular/compiler";
import { CalendarServiceDetailService } from "app/services/calendar-service-detail.service";

@Component({
  selector: 'app-calendar-year-v2',
  templateUrl: './calendar-year-v2.component.html',
  styleUrls: ['./calendar-year-v2.component.css']
})
export class CalendarYearV2Component implements OnInit {

  // see http://michaelbromley.github.io/ngx-pagination/#/advanced

  public targetYear: number;

  public data: any[any] = [];
  public filteredData: any[any] = [];

  public numberOfRecords = 0;
  public pageNumber = 1;
  public isLoadingData: boolean;
  public tablePositionStatusLabel: string;

  public search: String;
  public csvLink: string;

  constructor(
    private apiSvc: ApiService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public calendarSvc: CalendarService,
    private calendarServiceDetailSvc: CalendarServiceDetailService
  ) {
    this.calendarSvc.numberOfRecordsChanged.subscribe(() => {
      this.renderNumberOfEntries();
    });
  }

  ngOnInit() {

    window.addEventListener("resize", () => {this.resizeBrowser();});

    this.numberOfRecords = Number(localStorage.getItem("numberOfCalendarRecordsToDisplay"));
    if (this.numberOfRecords === 0) {
      this.numberOfRecords = 15;
    }

    // We either have the date, or the year. Not both

    this.route.params.map(p => p.year).subscribe(
      (year: number) => {
        console.log("year subscribe", year);
        if (year !== undefined) {
          console.log("Get year", year);
          this.targetYear = year;
          this.GetYear(year);
      }
    });

    this.route.params.map(p => p.date).subscribe(
      (date) => {
        console.log("date subscribe", date);
        if (date !== undefined) {
          // this.targetDate = new Date()
          // See if this date is in the existing set
          // Determine the lit year of this specified date...

          if (date === "today") {
            console.log("GO TO TODAY", new Date());
            this.goToSpecificDate(new Date());
          } else {
            console.log("Get goToSpecificDate", date);
            this.goToSpecificDate(new Date(date));
          }

       } else {

      }
    });

  }

  ngAfterViewChecked() {
    this.resizeBrowser();
  }

  public resizeBrowser() {
    var table = document.getElementById("scrollableTable");
    if (table) {
     // console.log("TABLE EXISTS");
 
        var totalHeight = window.innerHeight;
        var footerHeight = this.getOffsetHeight("pageButtons") + this.getOffsetHeight("page-footer");
        var targetHeight = totalHeight - table.offsetTop - footerHeight - 40;

        table.style.maxHeight = targetHeight + "px";

       // console.log(totalHeight, table.offsetTop, footerHeight, targetHeight);

      } else {
      //  console.log("TABLE DOES NOT EXIST");
      }
  }

  public getOffsetHeight(id:string) {
    var element = document.getElementById(id);
    if (element != null) return element.offsetHeight;
    return 0;
  }

  public SetCsvLink(year: number) {
    this.csvLink = this.apiSvc.baseUrl + "CalendarExport/ExportYear?liturgicalYear=" + year;
  }

  private GetYear(year: number): Promise<void> {

    console.log("getting year", year);
    this.isLoadingData = true;

    this.SetCsvLink(year);

    this.data = [];

    const p = new Promise<void>((resolve, reject) => {

      this.apiSvc.get("calendar/v2/getyear/" + year, null).subscribe(
        (s: any[any]) => {

          this.processResults(s);

          resolve();
          this.isLoadingData = false;
        },
        (err) => {
          console.log(err);
          alert(err);
          this.isLoadingData = false;
          reject(err);
        }
      );

    });

    return p;
  
  }

  private processResults(s: any[any]) {

    console.log(s);
    const today = new Date();

      
    s.forEach(element => {
      const localDate = new Date(parseInt(element.Date.substr(6), null));
      const utcDate = new Date((localDate.getUTCMonth() + 1) + "-" + localDate.getUTCDate() + "-" + localDate.getUTCFullYear());
      element.Date = utcDate;

      element.IsToday = false;
      if (utcDate.toDateString() === today.toDateString()) {
        element.IsToday = true;
      }

      var availableSearchTerms: string[] = [];

      //REMOVE ANY RESULTS WHERE IsAvailableHolyEucharistService == false; 
      var services = element.Services; //.filter(service => service.IsAvailableHolyEucharistService == true);
      element.Services = services;

      element.Services.forEach(service => {
 
       service.AdjustedServiceName = service.Name;

       if (service.IsTransferred == true) {
        service.AdjustedServiceName = service.AdjustedServiceName + " (Transferred)";
       }

       if (service.FeastType == "Lesser Feast") {
         service.AdjustedServiceName = service.AdjustedServiceName + ", " + service.LectionarySource_Name;
       }
       
       if (service.ProperNumber != null) {
        service.AdjustedServiceName = service.AdjustedServiceName + ", Proper " + service.ProperNumber;
       }

      //  if (service.TotalMappings == 0) {
      //   service.AdjustedServiceName = service.AdjustedServiceName + " - NO MAPPINGS FOR YEAR";
      // }

      // if (service.IsHolyEucharist != true) {
      //   service.AdjustedServiceName = service.AdjustedServiceName + " - NON HOLY EUCHARIST";
      // }

        // Set search terms for angular
        availableSearchTerms.push(service.AdjustedServiceName); 
        
      });

      element.CalendarItems.forEach(item => {  
        availableSearchTerms.push(item.Name); 
      });
 
      availableSearchTerms.push(element.LongDateStr);
      element.AvailableSearchTerms = availableSearchTerms;

      this.data.push(element);
      // console.log(element.Date);
    });

    this.filteredData = Object.assign([], this.data);
    this.calendarSvc.numberOfRecordsInFilter = this.data.length;

    console.log("processResults", this.data);

  }

  private dateTimeReviver = function (key, value) {
    var a;
    if (typeof value === 'string') {
        a = /\/Date\((\d*)\)\//.exec(value);
        if (a) {
            return new Date(+a[1]);
        }
    }
    return value;
}

//#region "Modals"

 
  public showServiceProperties(service: any, date: any, liturgyType: number) {
    console.log(service, date);
    
    const dialogRef = this.dialog.open(CalendarYearDetailServiceComponent, {
      data: {
        service: service, 
        date: date,
        liturgyType: liturgyType
      },
    });
  }

  public selectServiceForLiturgyType(date: any, liturgyType: number) {

    console.clear();
    console.log(liturgyType, date);
  
    // //Holy eucharist services are not handled by this function
    

    this.calendarServiceDetailSvc.getAvailableServices(date, liturgyType).then(
      (result: any[])=> {
       
        if (result.length == 0) {
          alert("There are no services to show for this date");
        } else if (result.length == 1) {
          //Go directly to that date/service 
          this.showServiceProperties(result[0], date, liturgyType);
        } else { 
          console.log("choose service");
          this.showServiceSelection(date, result, liturgyType);
        }  
        
      }
    )

  }

  public showServiceSelection(date: any, services: Service[], liturgyType: number) {

    const dialogRef = this.dialog.open(CalendarYearSelectServiceComponent, {
      data: {
        services: services, 
        date: date,
        liturgyType: liturgyType
      },
    }); 

  }

  public showNoteProperties(note: any) {
    const dialogRef = this.dialog.open(CalendarYearDetailNoteComponent, {
      data: note,
    });
  }

  //#endregion

  public changeNumberOfRecords() {
    localStorage.setItem("numberOfCalendarRecordsToDisplay", this.numberOfRecords.toString());
    this.renderNumberOfEntries();
  }
  
  //#region "Navigation"
  public previous() {
    this.pageNumber -= 1;

    if (this.pageNumber <= 0) {
      this.targetYear -= 1;
      this.GetYear(this.targetYear).then(
        (x) => {
          this.last();
        }
      );
    } else {
    }

  }

  public next() {

    this.pageNumber += 1;

    console.log("next", this.targetYear, this.pageNumber, this.getNumberOfPages());
    if (this.pageNumber > this.getNumberOfPages()) {
      this.targetYear += 1;
      this.GetYear(this.targetYear).then(
        (x) => {
          this.first();
        }
      );
    } else {
    }

  }

  public first() {
    this.goToPage(1);
  }

  public last() {
    this.goToPage(this.getNumberOfPages());
  }

  public goToPage(pageNumber: number) {
    this.pageNumber = pageNumber;

    this.renderNumberOfEntries();
  }

  private getNumberOfPages() {
    console.log("getNumberOfPages", )
      return Math.ceil(this.data.length / Number(this.numberOfRecords));
  }


  private renderNumberOfEntries() {

    setTimeout(() => {
      var startingPosition = (this.pageNumber - 1) * this.numberOfRecords;
      if (this.pageNumber === 1) {
        startingPosition = 1;
      }

      var endingPosition = startingPosition + (this.numberOfRecords - 1);
      if (endingPosition > this.calendarSvc.numberOfRecordsInFilter) {
        endingPosition = this.calendarSvc.numberOfRecordsInFilter;
      };

      this.tablePositionStatusLabel = "Showing " +
        startingPosition + " to " +
        endingPosition;
    }, 100);

  }
//#endregion

  private today() {
    this.goToSpecificDate(new Date());
  }

  private goToSpecificDate(date: Date) {

    console.log(date);

    this.calendarSvc.targetDate = date;
    this.search = "";
    const pageNumber = this.getPageNumberForSpecificDay(date);

    if (pageNumber == null) {
      this.getLiturgicalYearForSpecificDate(date).then(
        (year: number) => {

          this.targetYear = year;
          this.GetYear(year).then(
            (x) => {
              const newPageNumber = this.getPageNumberForSpecificDay(date);  // Now retry to get the position with the new dataset
              if (newPageNumber == null) {  // If we still can't find the date after we reloaded the dataset from the API, then error out
                alert("Cannot find today's date in the dataset");
              } else {
                this.goToPage(newPageNumber);
                this.scrollToTargetDate();
              }
            }
          ).catch(
            (ex) => {
              alert(ex);
            }
          );
        }
      );
    } else {
      this.goToPage(pageNumber);  // We found the date in the current dataset, skip to that page...
      this.scrollToTargetDate();
    }

  }

  private getPageNumberForSpecificDay(targetDate: Date): number {

      console.log("getPageNumberForSpecificDay", targetDate);
      const positionInDataSet = this.data.map((x) => {
        return this.isDateMatchWithTarget(x, targetDate);
      }).indexOf(true);

      if (positionInDataSet < 0) {
        return null;
      }

      var targetPageIndex = (Number(positionInDataSet) / this.numberOfRecords);
      var actualPageNumber = Math.floor(targetPageIndex) + 1;
      console.log(positionInDataSet, targetPageIndex, actualPageNumber);
      return actualPageNumber;
  }

  private isDateMatchWithTarget(sourceDate: any, targetDate: Date): boolean {

    if (targetDate === undefined) { return false; }

    if (
      sourceDate.DateDay === targetDate.getUTCDate() &&
      sourceDate.DateMonth === targetDate.getUTCMonth() + 1 &&  // Months are zero based, so add 1
      sourceDate.DateYear === targetDate.getUTCFullYear()
    ) {
      // console.log("SAME DAY", sourceDate, targetDate.getUTCDate(), targetDate.getUTCMonth() + 1, targetDate.getUTCFullYear());
      return true;
    }
    return false;
  }

  private getLiturgicalYearForSpecificDate(date: Date): Promise<number> {

      console.log("getLiturgicalYearForSpecificDate", date);

      const p = new Promise<number>((resolve, reject) => {

        //var date = date.toJSON();
        var dateStr =  (date.getMonth() + 1) + "-" + date.getDate() + "-" + date.getFullYear();

        this.apiSvc.get("calendar/getliturgicalyear/" + dateStr, null).subscribe(
          (year: number) => {
            resolve(year);
          },
          (err) => {
            console.log(err);
            alert(err);
            reject(err);
          }
        );

      });

      return p;
    }

    public getClasses(serviceDate?: any): any {
      const isTargetDate = this.isDateMatchWithTarget(serviceDate, this.calendarSvc.targetDate);
      const isSunday = serviceDate.Date.getUTCDay() === 0;
      const classObj = {'dateRow': true, 'sunday': isSunday, 'todaysDate': serviceDate.IsToday, 'targetDate': isTargetDate};
      return classObj;
    }

    private scrollToTargetDate() {

      console.log("scrollToTargetDate");
      setTimeout(
        () => {

          var matches = document.getElementsByClassName("targetDate");
          console.log(matches);
          if (matches.length > 0) {
            matches[0].scrollIntoView({behavior: "smooth"});
          }

        }, 100
      )

    }

}

